// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "init" + "." + "4d50f7cff7d24a0d1138" + ".js";
};